class LanguageModel
{
    english: string = "";
    french: string = "";
    lang1: string = "";
    lang2: string = "";
}

export default LanguageModel;